import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition } from '../../models';

class WtRolesMultiSelectController implements angular.IComponentController {
    formController: angular.IFormController;
    model: string[];
    roles: { name: string, id: string }[];

    static $inject = [];

    drop(data: { itemId: string }): void {
        const id = data.itemId.replace('id', '');
        if (_.some(this.roles, r => r.id === id) && _.every(this.model, u => u !== id)) {
            const found = _.find(this.roles, r => r.id === id);
            this.model.push(found.name);
            this.formController.$setDirty();
        }
    }
}

export const wtRolesMultiSelect: ComponentDefinition = {
    componentId: 'wtRolesMultiSelect',
    template: require('./rolesMultiSelect.component.html'),
    controller: WtRolesMultiSelectController,
    controllerAs: 'vm',
    bindings: {
        model: '=',
        roles: '=',
        isEditMode: '=',
        formController: '='
    }
};
